export default {
  // currentPageProducts: (state) => {
  //   let index = (state.currentPageNumber - 1) * state.productsPerPage;
  //   let filteredProducts = state.products;
  //   // filter by manufacturer
  //   if (state.filteredManufacturerIds.length > 0) {
  //     filteredProducts = filteredProducts.filter((p) =>
  //       state.filteredManufacturerIds.includes(p.manufacturerId)
  //     );
  //   }
  //   if (state.filteredSupplierIds.length > 0) {
  //     filteredProducts = filteredProducts.filter((p) =>
  //       state.filteredSupplierIds.includes(p.supplierId)
  //     );
  //   }
  //   return filteredProducts.slice(index, index + state.productsPerPage);
  // },
  pageCount: (state) => Math.ceil(state.productsTotal / state.productsPerPage),
};
